import { Component, EventEmitter, OnInit, Renderer2, ChangeDetectionStrategy } from '@angular/core';
import { DateRange } from '../../../../shared/components/date-range.component';
import { LPGDistData, LpgDistReportSummary, LPGDistService, Payment, ToolbarItem } from './../../../lpg-dist.service';
import momentJ from 'moment-jalaali';
import { OrganisationService } from 'src/app/organisation/organisation.service';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import { Router } from '@angular/router';
import { LpgDistToolbarComponent } from 'src/app/lpg-dist/lpg-dist-toolbar/lpg-dist-toolbar.component';
import { UserLocalStoreService } from 'src/app/shared/services/user-local-store.service';
import {
  PgDateRangeTitleComponent,
  PgDateRangeTitleEnum,
  PgTitleComponent,
  PgToolbarComponent
} from '../../../../shared/components/title-bar/title-bar.component';
import { saveAs } from 'file-saver';
import { DateTimeHelpers } from 'src/app/shared/helpers/date-time.helpers';
import { KeycloakService } from 'src/app/authentication/keycloak.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { AgGridModule } from 'ag-grid-angular';
import { GridOptions, GridReadyEvent } from 'ag-grid-community';
import { AgGridService } from 'src/app/shared/ag-grid/ag-grid.service';

@Component({
  selector: 'app-lpg-dist-payment-detail',
  templateUrl: './lpg-dist-payment-detail.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SharedModule, AgGridModule],
})
export class LpgDistPaymentDetailComponent implements OnInit,
  PgTitleComponent, PgDateRangeTitleComponent, PgToolbarComponent {
  title = new EventEmitter<string>();
  dateRangeSubTitle = new EventEmitter<[DateRange, PgDateRangeTitleEnum]>();
  toolbarComponentType = LpgDistToolbarComponent;

  toolbarComponent!: LpgDistToolbarComponent;
  company: Organisation = Organisation.create();
  selectedOrganisation: Organisation = Organisation.create();
  companies: Organisation[] = [];
  total?: number;
  paymentSummary: LpgDistReportSummary[] = [];
  loading: LPGDistData[] = [];
  edit: boolean = false;
  paymentData?: Payment;
  dataTable: Payment[] = [];
  showEntry: boolean = false;
  dateRange: DateRange = {
    startDate: new Date(),
    endDate: new Date()
  };
  organisations: Organisation[] = [];
  _settings!: ToolbarItem;
  gridOptions: GridOptions = {};

  constructor(private _lpgDistService: LPGDistService,
    private _router: Router,
    private _organisationService: OrganisationService,
    private _keycloakService: KeycloakService,
    private _userLocalStorage: UserLocalStoreService,
    private _renderer: Renderer2) { }

  columnDefs = [
    {
      headerName: 'شرکت',
      field: 'companyId',
      cellRenderer: (row: any) => this.formatOrganisation(row.data.companyId),
    },
    {
      headerName: 'تاریخ',
      field: 'payTimestamp',
      cellRenderer: (row: any) => DateTimeHelpers.formatPersianLocalDate(row.data.payTimestamp)

    },
    {
      headerName: 'مبدا',
      field: 'sourceOrganisationId',
      cellRenderer: (row: any) => this.formatOrganisation(row.data.sourceOrganisationId)
    },
    {
      headerName: 'شماره فیش',
      field: 'paymentBillNo',
    },
    {
      headerName: 'میزان خریداری شده',
      field: 'totalWeight',
      cellRenderer: (row: any) => parseInt(row.data.totalWeight).toLocaleString('en-US'),
    },
    {
      headerName: 'مبلغ خریداری شده',
      field: 'wholePayment',
      cellRenderer: (row: any) => parseInt(row.data.wholePayment).toLocaleString('en-US'),
    },
    {
      headerName: 'ویرایش',
      cellRenderer: (row: any) => AgGridService.editButton(
        this._renderer,
        this._router,
        this.editPayment,
        row.data
      )
    },

  ];

  ngOnInit() {
    this.gridOptions = AgGridService.getOptions();
    this.toolbarComponent.excelExport = this.xlsxReport;
    this.initPage();
  }

  // deleteButton = (service: LPGDistService, data: Payment) => {
  //   data.isDeleted = true;
  //   service.updatePayment(data).subscribe(() => {
  //     console.log('payment deleted');
  //     this.refresh(this._settings);
  //   });
  // };

  hasRole(roleName: string) {
    return this._keycloakService.hasRole(roleName);
  }

  gridSetting(event: GridReadyEvent) {
    AgGridService.setting(event);
  }

  initPage() {
    this._settings = this._userLocalStorage.get<ToolbarItem>('LpgDistPaymentDetailComponent');
    if (!this._settings || !this._settings.dateRange) {
      const endDate = momentJ().endOf('day').toDate().getTime();
      const startDate = momentJ(endDate).startOf('jMonth').toDate().getTime();
      this._settings = {
        companyId: 'iran.parsagroup.orsagas',
        dateRange: {
          startDate: new Date(startDate),
          endDate: new Date(endDate)
        }
      };
      this.dateRange = {
        startDate: new Date(startDate),
        endDate: new Date(endDate)
      };
    } else {
      this.dateRange = {
        startDate: new Date(this._settings.dateRange.startDate),
        endDate: new Date(this._settings.dateRange.endDate)
      };
    }
    this._organisationService.get().subscribe(c => {
      this.organisations = c;
      this.selectedOrganisation = this.organisations.find(co => co.name === this._settings.companyId) || Organisation.create();
      this.toolbarComponent.dateRange = {
        startDate: this.dateRange.startDate,
        endDate: this.dateRange.endDate
      };
      this.toolbarComponent.jalali = true;
      this.toolbarComponent.singleDate = false;
      this.toolbarComponent.visibleOrganisation = true;
      this.updateTable(this._router, this._lpgDistService);
      this.toolbarComponent.organisations = this.organisations
        .filter(o => ['domestic'].filter(s => o.properties[s]).length > 0);
      this.toolbarComponent.selectedOrganisation = this.organisations.find(co => co.name === this._settings.companyId) || Organisation.create();
      this.toolbarComponent.itemsSelected.subscribe(t => {
        this.refresh(t);
      });
    });
  }

  updateTable(_router: Router, _lpgDistService: LPGDistService) {
    this.title.emit('Payments List');
    this.dateRangeSubTitle.emit([this.dateRange, PgDateRangeTitleEnum.persian]);
    _lpgDistService.getPaymentHistory(this.selectedOrganisation.name,
      this.dateRange.startDate.getTime(),
      this.dateRange.endDate.getTime()).subscribe(sum => {
      this.dataTable = this.sortArray(sum);
    });
  }

  organisationValueFormatter(data: Organisation) {
    return data.nameTranslations['fa'];
  }

  getTotalWight() {
    this.total = this.dataTable.reduce(((previousValue, currentValue) =>
      previousValue + currentValue.totalWeight), 0);
  }

  editPayment(router: Router, selectedRecord: Payment) {
    router.navigate(['/lpg-dist/payments',
      encodeURIComponent(selectedRecord.companyId),
      encodeURIComponent(selectedRecord.payTimestamp.toString()),
      encodeURIComponent(selectedRecord.paymentBillNo)])
      .then(_ => _);
  }

  formatOrganisation(organisationId: string) {
    const organisation = this.organisations.find(o => o.name === organisationId);
    return (organisation !== undefined) ? organisation.nameTranslations['fa'] : '';
  }

  xlsxReport() {
    this._lpgDistService.downloadPaymentsExcel(
      this.selectedOrganisation.name,
      this.dateRange.startDate.getTime(),
      this.dateRange.endDate.getTime()).subscribe(file => {
      saveAs(file.body || '', 'lpg-dist-payments.xlsx');
    });
  }

  sortArray(data: Payment[]) {
    const test = data.sort((l1, l2) => {
      if (l1.payTimestamp < l2.payTimestamp) {
        return -1;
      }
      if (l1.payTimestamp > l2.payTimestamp) {
        return 1;
      }
      return 0;
    });
    return test;
  }

  refresh(item: ToolbarItem) {
    if (item.companyId) {
      this._settings = item;
      this._userLocalStorage.save('LpgDistPaymentDetailComponent', this._settings);
      this.selectedOrganisation = this.organisations.find(o => o.name === item.companyId) || Organisation.create();
    }
    this.dateRange = {
      startDate: new Date(this._settings.dateRange.startDate),
      endDate: new Date(this._settings.dateRange.endDate)
    };
    this.updateTable(this._router, this._lpgDistService);
  }
}
